import {Alert, Autocomplete, Box, TextField, TextFieldProps} from "@mui/material";
import {Controller, useFormContext} from "react-hook-form";
import {merge} from "lodash";
import * as React from "react";

type FormInputAutocomplete2Props = Omit<TextFieldProps, 'name'> & {
   name: string
   rules?: any
   labelMapper?: (option: any) => string
   options: any[]
   label?: string
}

export default function FormInputAutocomplete2({
                                                  name,
                                                  rules,
                                                  options,
                                                  label,
                                                  labelMapper,
                                                  style,
                                                  fullWidth,
                                                  placeholder
                                               }: FormInputAutocomplete2Props) {
   const {control, formState: {errors}} = useFormContext();
   const showError = !!errors[name];

   // Handle paste event
   const handlePaste = (event: React.ClipboardEvent<HTMLDivElement>, onChange: (value: any) => void, currentValue: any[]) => {
      // Prevent the default paste behavior
      event.preventDefault();

      // Get the clipboard data
      const pasteData = event.clipboardData.getData('text');

      // Split the pasted data into rows (handle both Windows and Unix line endings)
      const rows = pasteData.split(/[\r\n]+/)
         .map(row => row.trim())
         .filter(row => row.length > 0);  // Remove empty rows

      // Create new values array with existing values plus new rows
      const newValues = [...(currentValue || []), ...rows];

      // Update the form
      onChange(newValues);
   };

   return (
      <Controller
         name={name}
         control={control}
         rules={rules}
         defaultValue={[]}  // Changed from null to empty array for multiple values
         render={({
                     field: {ref, onChange, value, ...field},
                     fieldState: {error}
                  }) => {
            return (
               <Autocomplete
                  {...field}
                  value={value}
                  freeSolo
                  multiple
                  fullWidth={fullWidth}
                  handleHomeEndKeys
                  options={options}
                  getOptionLabel={labelMapper}
                  renderInput={({size, InputProps, InputLabelProps, ...rest}) => {
                     const newStyle = merge(style, {
                        border: showError ? '1px solid #f00000' : '1px solid #d0d0d0',
                        marginBottom: '8px'
                     });

                     const newProps = merge(InputProps, {
                        disableUnderline: true,
                        style: {backgroundColor: 'transparent'},
                        onPaste: (e: React.ClipboardEvent<HTMLDivElement>) =>
                           handlePaste(e, onChange, value)
                     });

                     return <Box>
                        <TextField
                           size={"small"}
                           label={label}
                           variant="filled"
                           margin={"none"}
                           style={newStyle}
                           placeholder={placeholder}
                           InputLabelProps={{
                              shrink: true,
                           }}
                           InputProps={newProps}
                           {...rest}
                        />
                        {showError && <Alert variant="filled" severity="error">{errors[name]?.message}</Alert>}
                     </Box>
                  }}
                  onChange={(e, item) => {
                     onChange(item)
                  }}
               />
            );
         }}
      />
   );
}